import PropTypes from 'prop-types';
import React from 'react';
import Gallery from 'react-grid-gallery'

export class ImageGrid extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            images: this.props.images
        };

        this.onSelectImage = this.onSelectImage.bind(this);

    }

    onSelectImage (index, image) {
        // var images = this.state.images.slice();
        // var img = images[index];
        // if(img.hasOwnProperty("isSelected"))
        //     img.isSelected = !img.isSelected;
        // else
        //     img.isSelected = true;
        //
        // this.setState({
        //     images: images
        // });
    }

    render () {
        return (
            <div style={{
            display: "block",
                minHeight: "1px",
                width: "100%",
                overflow: "auto"}}>
    <Gallery
        style={{
            display: "flex"}}
        images={this.state.images}
        onSelectImage={this.onSelectImage}
        lightboxWidth={1536}
        rowHeight={500}
        margin={5}
        />
        </div>
    );
    }
}

ImageGrid.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string.isRequired,
            thumbnail: PropTypes.string.isRequired,
            srcset: PropTypes.array,
            caption: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element
            ]),
            thumbnailWidth: PropTypes.number.isRequired,
            thumbnailHeight: PropTypes.number.isRequired,
            isSelected: PropTypes.bool
        })
    ).isRequired
};

